import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { ComponentType } from 'react';

export const NotFound: LoadableType<any> = LoadableAfterPaint({
	loader: async () =>
		// eslint-disable-next-line
		(await import(/* webpackChunkName: "loadable-NotFound" */ '../src/NotFound'))
			.NotFound as ComponentType<any>,
});
